var React = require('react');

function DescaleInline (props) {
    return React.createElement("g",props,[React.createElement("polygon",{"points":"21.4,4.1 20,2.6 15,7.6 15,4 13,4 13,11 20,11 20,9 16.4,9 ","key":0}),React.createElement("polygon",{"points":"4.2,13 4.2,15 7.7,15 2.8,20 4.2,21.4 9.2,16.4 9.2,20 11.2,20 11.2,13 ","key":1})]);
}

DescaleInline.defaultProps = {};

module.exports = DescaleInline;

DescaleInline.default = DescaleInline;
